import "bootstrap/dist/css/bootstrap.min.css"; import * as OFMSUI from "react-bootstrap"; import $ from "jquery"; import { useFormik, FormikProvider, Field, } from "formik"; import React, { useState } from "react"; import { useHistory } from "react-router-dom"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import HousingService from "../../../Services/HousingService"; import { Form, Table, } from "react-bootstrap"; import jsPDF from "jspdf"; import moment from "moment-timezone"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import { AiOutlineSearch } from "react-icons/ai"; import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { GetDetails, SubmitButton } from "../../utils/commonFunctions";
import { store } from "../../../App";

const GLedger = () => {
  const history = useHistory();
  const [TableEnable, setTableEnable] = useState(false); const [tableData, setTableData] = useState([]); const [search, setSearch] = useState(""); const [searchText, setSearchText] = useState(""); const [currentPage, setCurrentPage] = useState(1); const Recordsperpage = 100; const lastindex = currentPage * Recordsperpage; const firstindex = lastindex - Recordsperpage; const records = tableData?.slice(firstindex, lastindex); const npage = Math.ceil(tableData?.length / Recordsperpage); const numbers = Array.from({ length: npage }, (e, index) => index + 1); const startSerialNumber = firstindex + 1; const [Headsnmaelist, setHeadsnmaelist] = useState(); const [loading, setLoading] = useState(false); const [distList, setDistList] = useState();
  const [showOB, setShowOB] = useState(false);
  const [obData, setObData] = useState([]);
  React.useEffect(() => {
    HousingService.CGG_District().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistList(options); } });
  }, []);

  const todayDate = new Date();
  let year = todayDate.getUTCFullYear(); let month = todayDate.getMonth() + 1; let tDate = todayDate.getDate(); if (month < 10) { month = "0" + month; } if (tDate < 10) { tDate = "0" + tDate; }
  const maxDate = year + "-" + month + "-" + tDate;



  const handleSearch = (event) => {
    setSearchText(event.target.value);
    $(function () {
      function formatIndianCurrency(amount) { var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); return formatter.format(amount); }
      function tally(selector) { $(selector).each(function () { var total = 0, column = $(this).siblings(selector).addBack().index(this); $("#my-table tbody tr").each(function () { total += parseFloat($(".sum:eq(" + column + ")", this).html()) || 0; }); $(this).html(formatIndianCurrency(total)); }); }
      tally("td.total");
    });
  };
  const filteredData = searchText.length > 0 ? tableData?.filter((item) => { return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); })); }) : records;


  function prevPage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
      $(function () {
        function formatIndianCurrency(amount) { var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); return formatter.format(amount); }
        function tally(selector) { $(selector).each(function () { var total = 0, column = $(this).siblings(selector).addBack().index(this); $("#my-table tbody tr").each(function () { total += parseFloat($(".sum:eq(" + column + ")", this).html()) || 0; }); $(this).html(formatIndianCurrency(total)); }); } tally("td.total");
      });
    }
  }

  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1); $(function () {
        function formatIndianCurrency(amount) { var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); return formatter.format(amount); }
        function tally(selector) { $(selector).each(function () { var total = 0, column = $(this).siblings(selector).addBack().index(this); $("#my-table tbody tr").each(function () { total += parseFloat($(".sum:eq(" + column + ")", this).html()) || 0; }); $(this).html(formatIndianCurrency(total)); }); } tally("td.total");
      });
    }
  }

  function ChangeCpage(id) {
    setCurrentPage(id); $(function () {
      function formatIndianCurrency(amount) { var formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); return formatter.format(amount); }
      function tally(selector) { $(selector).each(function () { var total = 0, column = $(this).siblings(selector).addBack().index(this); $("#my-table tbody tr").each(function () { total += parseFloat($(".sum:eq(" + column + ")", this).html()) || 0; }); $(this).html(formatIndianCurrency(total)); }); } tally("td.total");
    });
  }

  React.useEffect(() => {
    HousingService.headsNameApi().then((res) => { if (res.data) { let options = res.data.map((item, i) => { if (item !== null) { return (<option key={i} value={item.headid}> {item.heads} </option>); } }); setHeadsnmaelist(options); } });
  }, []);

  const formik = useFormik({
    initialValues: { fromDate: "", toDate: "", district: "", headid: "All", },
    validate: (values) => {
      const errors = {}; if (!values.fromDate) { errors.fromDate = "From Date is required"; } if (!values.toDate) { errors.toDate = "To Date is required"; } if (values.fromDate && values.toDate && values.fromDate > values.toDate) { errors.toDate = "To Date must be greater than From Date"; } return errors;
    },

    onSubmit: async (values) => {
      let params = {
        fromDate: moment(values.fromDate).format("DD/MM/YYYY"),
        toDate: moment(values.toDate).format("DD/MM/YYYY"),
        headid: formik.values.headid,
        district: formik.values.district,
      };

      let param = {
        fromDate: moment(values.fromDate).format("DD/MM/YYYY"),
        headid: formik.values.headid,
        district: formik.values.district,
      };

      store.dispatch({ type: "SHOW_SPINNER" });

      try {
        // 🔹 Opening Balance API
        if (formik.values.headid === "All") {
          setShowOB(false);
          setObData([]);
        } else {
          const response = await HousingService.GetGeneralLeadgerReportOB(param);

          if (response?.data && response.data.length > 0) {
            setShowOB(true);
            setObData(response.data);
          } else {
            setShowOB(false);
            setObData([]);
          }
        }

        // 🔹 Table Data API
        const res = await HousingService.GetGeneralLeadger_Report(params);

        if (res?.data && res.data.length > 0) {
          setTableData(res.data);
        } else {
          setTableData([]);
        }

        // 🔹 Column Totals Calculation
        $(function () {
          function formatIndianCurrency(amount) {
            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(amount);
          }

          function tally(selector) {
            $(selector).each(function () {
              let total = 0;
              let column = $(this).siblings(selector).addBack().index(this);

              $("#my-table tbody tr").each(function () {
                total += parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });

              $(this).html(formatIndianCurrency(total));
            });
          }

          tally("td.total");
        });

      } catch (error) {
        console.error(error);
        setShowOB(false);
        setObData([]);
        setTableData([]);
      } finally {
        store.dispatch({ type: "HIDE_SPINNER" });
        setTableEnable(true);
      }
    }

  });

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: '-15px' }}>General Ledger</h1> </div> </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <button className="btn btn-primary" style={{ textAlign: "right", float: "right", marginTop: "17px" }} type="reset" onClick={() => history.goBack()} > Back </button> </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}> <th>From Date:</th> <Field name="fromDate" className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={maxDate} /> {formik.touched.fromDate && formik.errors.fromDate ? (<div className="invalid-feedback"> {formik.errors.fromDate} </div>) : null}
              </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}> <th>To Date:</th> <Field name="toDate" className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={maxDate} /> {formik.touched.toDate && formik.errors.toDate ? (<div className="invalid-feedback">{formik.errors.toDate}</div>) : null} </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}> <th> District name: <span className="mandatory" style={{ color: "red" }}>  * </span> </th> <Field component="select" name="district" className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} > {formik.touched.district && formik.errors.district ? (<div className="invalid-feedback"> {formik.errors.district} </div>) : null} <option value="">Select</option> {distList} </Field> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}> <th>Head of Account:</th> <Field name="headid" className={formik.touched.headid && formik.errors.headid ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} component="select" > <option value="All">....ALL....</option> {Headsnmaelist} </Field> {formik.touched.headid && formik.errors.headid ? (<div className="invalid-feedback">{formik.errors.headid}</div>) : null} </OFMSUI.Col>
            </OFMSUI.Row>
            <OFMSUI.Row className="mb-3">
              <SubmitButton title="GetDetails" />
            </OFMSUI.Row>
            <OFMSUI.Row>

              {TableEnable && (
                <div>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                      <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                        <input type="text" id="#filterInput" placeholder="Search " style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input>
                      </div>
                    </OFMSUI.Col>

                    <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                      <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} >
                        <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="GeneralLedger" sheet="tablexls" buttonText="Excel" >
                        </ReactHTMLTableToExcel>
                      </button>
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  {showOB && obData?.length > 0 && tableData?.length > 0 && (
                    <>
                      <h6 style={{ textAlign: "center" }}>
                        Opening Balance As on{" "}
                        {moment(formik.values.fromDate).format("DD/MM/YYYY")} is Rs {" "}
                        {Math.abs(obData[0]?.start_bal)}{" "}
                        {Number(tableData[0]?.credit) === 0 &&
                          Number(tableData[0]?.debit) > 0
                          ? "Dr"
                          : Number(tableData[0]?.debit) === 0 &&
                            Number(tableData[0]?.credit) > 0
                            ? "Cr"
                            : ""}
                      </h6>
                    </>
                  )}


                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                      <tr className="table_countshead"> <th>S No.</th> <th>Date</th> <th>Voucher No</th> <th>Head of the Account</th> <th>Description</th> <th>Debit</th> <th>Credit</th>
                        {/* <th>Dr/Cr</th> */}
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData?.filter((element) => element.receiptno.toLowerCase().includes(search.toLowerCase())).map((tableData, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center", width: "70px" }} > {startSerialNumber + i} </td>
                          <td style={{ width: "110px" }}>{tableData.date}</td> <td style={{ width: "140px" }}> {tableData.receiptno} </td> <td style={{ width: "260px" }}> {tableData.headname} </td> <td style={{ width: "500px" }}> {tableData.description} </td>
                          <td style={{ width: "150px" }} className="sum"> {tableData.debit} </td>
                          <td style={{ width: "150px" }} className="sum"> {tableData.credit} </td>
                          <td style={{ width: "150px" }} className="sum"> {tableData.balance_in_account} </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="table_countshead">
                        <td colSpan={5}>Total</td>
                        <td> {filteredData?.reduce((a, v) => a + v.debit, 0).toLocaleString("en-IN")} </td>
                        <td> {filteredData?.reduce((a, v) => a + v.credit, 0).toLocaleString("en-IN")} </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </Table>
                  <div>
                    <nav>
                      <ul className="pagination" style={{ overflow: "auto", marginTop: "20px" }}>
                        {/* Previous Button */}
                        <li className="page-item">
                          <button
                            className="btn btn-primary"
                            onClick={prevPage}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>

                        {/* Page Numbers */}
                        {numbers.reverse().map((n) => (
                          <li
                            className={`page-item ${currentPage === n ? "active" : ""}`}
                            key={n}
                          >
                            <button
                              className="page-link"
                              onClick={() => ChangeCpage(n)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "6px 12px",
                                cursor: "pointer"
                              }}
                            >
                              {n}
                            </button>
                          </li>
                        ))}

                        {/* Next Button */}
                        <li className="page-item">
                          <button
                            className="btn btn-primary"
                            onClick={nextPage}
                            disabled={currentPage === npage}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>

                </div>
              )}
            </OFMSUI.Row>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default GLedger;
